<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {};
  },
  methods: {},
  mounted() {
    //为pc则用iframe把移动端页面显示到页面中间
    let userAgentInfo = window.navigator.userAgent
		let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
		//pc
		if (!Agents.some(item => userAgentInfo.toLowerCase().includes(item.toLowerCase())) && !(self.frameElement && self.frameElement.tagName == 'IFRAME')) {
			// 检查页面是否已经有iframe   这个判断让页面拥有只保留一个iframe
			let ifrTag = document.getElementsByTagName('iframe')[0]
			if (ifrTag) {
				// 如果有，则删除它
				ifrTag.remove()
			} else {
				let ifrTag = document.createElement('iframe')
				document.body.innerHTML = ''
				ifrTag.setAttribute('src', window.location.href)
				let styleObj = {
					width: '480px',
					height: '100vh',
					position: 'absolute',
					left: '50%',
					transform: 'translateX(-50%)',
          border: '2px solid #ececec'
				}
        for (var key in styleObj) {
          ifrTag.style[key] = styleObj[key]
        }
				document.body.append(ifrTag)
			}
		}
  },
};
</script>
<style lang="less">
/*隐藏滚动条*/
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
  display: none;
}

/*两行溢出隐藏*/
.overFlowTwo {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

/*单行溢出隐藏*/
.overFlowOne {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*三行溢出隐藏*/
.overFlowThree {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

//列表无数据
.noDataBox {
  padding-top: 60px;
  color: #999999;
  font-size: 13px;
  text-align: center;
  padding-bottom: 60px;
  .icon-kong {
    font-size: 100px;
    color: #eee;
  }
  .icon-search {
    font-size: 80px;
    color: #ddd;
  }
}

//转发提示
.shareLayer {
  width: 100%;
  height: 150px;
  position: fixed;
  top: 0;
  left: 30px;
  z-index: 999999;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

//动态列表
.l_item {
  background-color: #ffffff;
  border-bottom: 10px solid #f5f5f5;
  padding: 20px 20px 10px 20px;
  .li_top {
    display: flex;
    align-items: center;
    position: relative;
    .trashIcon {
      position: absolute;
      z-index: 2;
      bottom: 10px;
      right: 0;
      .iconfont {
        font-size: 17px;
        margin-bottom: 20px;
        color: #ddd;
      }
    }
    .topIcon {
      position: absolute;
      z-index: 2;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
      font-size: 12px;
      color: #af1e23;
      width: 50px;
      height: 20px;
      background: rgba(214, 47, 47, 0.1);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        font-size: 10px;
        line-height: 10px;
        color: #af1e23;
        margin-right: 1px;
      }
    }

    .avatarImg {
      position: relative;
      .van-image {
        display: block;
        width: 40px;
        height: 40px;
        margin-right: 7px;
        border-radius: 50%;
        border: 1px solid #eee;
      }
      .renzheng {
        width: 17px;
        height: 17px;
        vertical-align: top;
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
    .width460 {
      width: 230px;
    }
    .width520 {
      width: 260px;
    }
    .li_top_r {
      font-size: 10px;
      color: #999;

      div {
        &:first-child {
          color: #586b95;
          font-weight: bold;
          font-size: 14px;
          display: flex;
          align-items: center;
          margin-bottom: 3px;
        }
      }
      .lrt_time {
        display: flex;
        align-items: center;
        span {
          margin-left: 4px;
        }
        div {
          padding: 0 6px;
          text-align: center;
          line-height: 14px;
          height: 14px;
          border-radius: 7px;
          font-size: 9px;
          color: #cc9999;
          border: 1px solid #cc9999;
          margin-left: 4px;
          -webkit-border-radius: 7px;
          -moz-border-radius: 7px;
          -ms-border-radius: 7px;
          -o-border-radius: 7px;
        }
      }
    }
  }
  .li_mid {
    padding: 0px 0px 5px 0px;
    .text-box {
      margin-top: 12px;
      color: #333;
      font-size: 15px;
      line-height: 24px;
    }
    .img-box {
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .van-image {
        width: 107px;
        height: 107px;
        background-color: #d0d0d0;
        margin: 6px 6px 0 0;
        &:nth-child(3n) {
          margin-right: 0px;
        }
      }
      .single {
        width: 150px;
        height: 150px;
      }
    }
    .video-box {
      width: 100%;
      height: 230px;
      margin-top: 10px;
      position: relative;
      .van-image {
        width: 100%;
        height: 100%;
        display: block;
      }
      div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .original-box {
      margin-top: 10px;
      background-color: #eee;
      display: flex;
      align-items: center;
      padding: 8px 10px;
      .van-image {
        width: 75px;
        height: 50px;
        margin-right: 15px;
        background-color: #999;
      }
      div {
        width: 230px;
        font-size: 11px;
        color: #333;
      }
    }
    .label-box {
      margin-top: 12px;
      display: flex;
      align-items: center;
      flex-flow: wrap;
      .circle,
      .topic {
        height: 20px;
        line-height: 20px;
        font-size: 11px;
        padding: 0 10px;
        color: #fff;
        border-radius: 10px;
        margin: 0 5px 10px 0;
        background-color: #f1f1f1;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        -ms-border-radius: 10px;
        -o-border-radius: 10px;
      }
      .iconfont {
        font-size: 12px;
        margin-right: 5px;
      }
      .circle {
        color: #57aa29;
      }
      .topic {
        color: #e67272;
      }
    }
  }
  .li_btm {
    font-size: 12px;
    color: #999;
    .van-col {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        margin-left: 2px;
      }
    }
  }
}

/* 广告位 */
.la_item {
  color: #333333;
  font-size: 15px;
  background-color: #ffffff;
  border-bottom: 10px solid #f5f5f5;
  padding: 12px 20px 16px 20px;
  .lai_view {
    margin-bottom: 9px;
  }
  .van-image {
    width: 100%;
    display: block;
    margin-top: 3px;
    /deep/.van-image__img {
      border-radius: 4px;
    }
  }
}

// 顶部搜索
.searchBox {
  background-color: #fff;
  /deep/.van-search__content {
    background-color: #f5f5f5;
  }
}

//店铺底部tab
.footerSBox {
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #fff;
  z-index: 1000;
  border-top: 1px solid #eee;
  color: #666666;
  padding: 6px 0 0 0;
  .footItem {
    float: left;
    height: 44px;
    width: 25%;
    font-size: 11px;
    color: #666;
    text-align: center;
    overflow: hidden;
    &:last-child {
      margin-right: 0;
    }
    .homeIcon {
      width: 22px;
      height: 22px;
    }
    .active {
      color: #333;
    }
  }
}

//直播
.liveItem {
  position: relative;
  display: flex;
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
  .van-image {
    width: 130px;
    height: 73px;
    display: block;
  }
  .liveStatus {
    position: absolute;
    z-index: 2;
    top: 12px;
    left: 8px;
    background-color: #ff3535;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 10px;
    padding: 0 4px;
    img {
      width: 15px;
      height: 15px;
      margin-right: 3px;
    }
  }
  .rightBox {
    width: 216px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    .title {
      color: #333;
      font-size: 14px;
    }
    .time {
      color: #666;
      font-size: 10px;
      margin-top: 6px;
    }
    .storeBox {
      display: flex;
      align-items: center;
      .van-image {
        width: 25px;
        height: 25px;
        display: block;
        border: 1px solid #eee;
      }
    }
    .name {
      width: 112px;
      color: #666;
      font-size: 10px;
      margin-left: 6px;
    }
    .visitBtn {
      width: 57px;
      height: 25px;
      line-height: 24px;
      border: 1px solid #d62f2f;
      border-radius: 12px;
      color: #d62f2f;
      font-size: 12px;
      text-align: center;
      margin-left: 10px;
    }
  }
}

//专题模块
.moduleBox {
  padding: 37px 0 34px 0;
  border-bottom: 9px solid #efefef;
  .lit_state {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    font-size: 10px;
    color: #ffffff;
    .lits_text {
      display: flex;
      align-items: center;
      height: 18px;
      padding: 0 5px;
      img {
        width: 15px;
        height: 15px;
        margin-right: 3px;
      }
    }

    .red {
      background-color: #ff3535;
    }

    .purple {
      background-color: #a421a6;
    }

    .orange {
      background-color: #ff8400;
    }
    .lits_time {
      padding: 0 5px;
      line-height: 18px;
      background-color: rgba(255, 132, 0, 0.6);
    }
  }

  .playIcon {
    width: 26px;
    height: 26px;
    position: absolute;
    z-index: 1;
    bottom: 3px;
    left: 3px;
  }
  .hasPrize {
    width: 35px;
    height: 35px;
    position: absolute;
    z-index: 1;
    right: 3px;
    top: 5px;
  }
  .coverImg {
    width: 100%;
    height: 100%;
    display: block;
  }

  /deep/.van-list__placeholder {
    display: none;
  }
  .li_btm {
    color: #333333;
    font-size: 11px;
    padding: 7px 7px 10px 7px;
    .company {
      display: flex;
      align-items: center;
      margin-top: 7px;
      .van-image {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 6px;
        border-radius: 50%;
      }
      div {
        width: 80%;
        color: #666666;
        font-size: 9px;
      }
    }
  }
  .headline {
    color: #000000;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }

  .more {
    font-size: 12px;
    color: #999;
    text-align: center;
    margin: 25px auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .live-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    .li_item {
      width: 175px;
      margin-bottom: 10px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.21);
      .li_top {
        width: 100%;
        height: 98px;
        position: relative;
      }
    }
  }

  .live-box3 {
    justify-content: start;
    .li_item {
      width: 113px !important;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.21);
      &:not(:nth-child(3n)) {
        margin-right: calc((100% - 339px) / 2);
      }
      .li_top {
        height: 113px !important;
      }
    }
  }
}

.hot-box {
  width: 200px;
  height: 30px;
  padding: 0 12px 0 15px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #ffe9ec, #e4efff);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  font-size: 12px;
  margin: 22px auto 27px;
}

.fireIcon {
  width: 13px;
  height: 16px;
}

//话题模块
.topicItem {
  padding: 15px 0;
  margin: 0 20px;
  color: #999999;
  font-size: 12px;
  line-height: 16px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ti_left {
    width: 217px;
    .tilTitle {
      color: #333333;
      font-size: 15px;
      line-height: 20px;
      margin-bottom: 7px;
    }
    .times {
      display: flex;
      margin-top: 13px;
      color: #666666;
      font-size: 11px;
      line-height: 13px;
      div {
        padding-left: 11px;
      }
    }
  }
  .tiImg {
    width: 100px;
    height: 75px;
    background: silver;
  }
}

.mask-layer {
  position: fixed;
  z-index: 31;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
</style>
